import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id"]
const _hoisted_3 = ["id", "src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      model: _ctx.state.newUser,
      id: _ctx.$style.fromParent,
      "label-width": "150px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          id: _ctx.$style.formInputParent
        }, [
          _createVNode(_component_el_form_item, {
            label: "アカウント名",
            class: _normalizeClass(_ctx.$style.input)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.state.newUser.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.newUser.name) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_form_item, {
            label: "メールアドレス",
            class: _normalizeClass(_ctx.$style.input)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.state.newUser.email,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.newUser.email) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_form_item, {
            label: "パスワード",
            class: _normalizeClass(_ctx.$style.input)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "password",
                modelValue: _ctx.state.newUser.pass,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.newUser.pass) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_el_form_item, {
            label: "パスワード再入力",
            class: _normalizeClass(_ctx.$style.input)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "password",
                modelValue: _ctx.state.newUser.confirmationPass,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.newUser.confirmationPass) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["class"])
        ], 8, _hoisted_1),
        _createElementVNode("div", {
          id: _ctx.$style.googleDocumentWrapper
        }, [
          _createElementVNode("iframe", {
            id: _ctx.$style.googleDocument,
            src: _ctx.agreementUrl.AGREEMENT_URL
          }, null, 8, _hoisted_3)
        ], 8, _hoisted_2),
        _createVNode(_component_el_checkbox, {
          label: "利用規約に同意する",
          modelValue: _ctx.state.newUser.agree,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.newUser.agree) = $event))
        }, null, 8, ["modelValue"]),
        _hoisted_4,
        _createVNode(_component_el_button, {
          color: _ctx.BUTTON_COLOR,
          round: true,
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(_component_el_icon, { class: "is-loading" }, {
              default: _withCtx(() => [
                _createVNode(_component_Loading)
              ]),
              _: 1
            }, 512), [
              [_vShow, _ctx.state.sending]
            ]),
            _createTextVNode(" アカウントを作成 ")
          ]),
          _: 1
        }, 8, ["color", "onClick"])
      ]),
      _: 1
    }, 8, ["model", "id"])
  ]))
}